import {
  composeCommunityMembershipCheckoutPolicyText,
  type ResolvedCommunityMembershipPolicies,
} from './community-membership-policy.policy';

export const LOAMIFY_PLATFORM_TERMS_URL = 'https://loamify.io/terms';
export const LOAMIFY_PLATFORM_PRIVACY_URL = 'https://loamify.io/privacy';

export type CommunityLegalCheckoutBundle = {
  platformTermsUrl: string;
  platformPrivacyUrl: string;
  creatorPolicies: ResolvedCommunityMembershipPolicies;
  communityRules: string | null;
  adultContent: {
    enabled: boolean;
    minimumAgeYears: number;
  };
  composedPolicyText: string | null;
};

export function composeCommunityLegalCheckoutBundle(params: {
  policies: ResolvedCommunityMembershipPolicies;
  communityRules?: string | null;
  adultContentEnabled?: boolean;
  minimumAgeYears?: number;
}): CommunityLegalCheckoutBundle {
  const creatorPolicies = params.policies;
  const communityRules = params.communityRules?.trim() || null;
  const composedPolicyText = composeCommunityMembershipCheckoutPolicyText(creatorPolicies);

  return {
    platformTermsUrl: LOAMIFY_PLATFORM_TERMS_URL,
    platformPrivacyUrl: LOAMIFY_PLATFORM_PRIVACY_URL,
    creatorPolicies,
    communityRules,
    adultContent: {
      enabled: params.adultContentEnabled ?? false,
      minimumAgeYears: params.minimumAgeYears ?? 18,
    },
    composedPolicyText,
  };
}

export function validateCommunityLegalCheckoutAcceptance(params: {
  bundle: CommunityLegalCheckoutBundle;
  acceptPlatformTerms: boolean;
  acceptGuidelines: boolean;
  acceptCreatorPolicies: boolean;
  confirmAdultContent?: boolean;
  isPaidCheckout: boolean;
}): { ok: true } | { ok: false; message: string } {
  if (!params.acceptPlatformTerms) {
    return { ok: false, message: 'You must accept the LOAMIFY Terms of Service and Privacy Policy' };
  }

  if (params.bundle.communityRules && !params.acceptGuidelines) {
    return { ok: false, message: 'You must accept the community guidelines' };
  }

  if (params.isPaidCheckout && !params.acceptCreatorPolicies) {
    return { ok: false, message: 'You must accept the creator membership policies' };
  }

  if (params.bundle.adultContent.enabled && !params.confirmAdultContent) {
    return {
      ok: false,
      message: `You must confirm you are at least ${params.bundle.adultContent.minimumAgeYears} years old`,
    };
  }

  return { ok: true };
}
